import React from 'react';
import PropTypes from 'prop-types';

export const NbttApplyLayout = ({ children }) => {
  return (<div id="NbttApplyLayout__Application">{children}</div>)
};

NbttApplyLayout.propTypes = {
  children: PropTypes.any
}